import * as React from 'react';

import styles from '../styles.module.scss';

const Description: React.FC = () => {

	return (
		<div className={styles['notification-settings__description']}>
			<div className="m-b-xs">
				Add emails to send daily notifications regarding users that are added or removed from the organization.
			</div>
			<div className="m-b-xs">
				If a user has only been deactivated in one company, while still being active in another,
				they will not be included in the notification content.
			</div>
		</div>
	);
};

export default React.memo(Description);
